 import React from "react";
import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";
import "./AirCauses.css";

import pollutionImg from "../../assets/outdoor.jpg";

const AirCauses = () => {
  return (
    <>
      <Navbar />
      <SecondNavbar />

      <div className="air-container">
        <h1>Causes of Air Pollution</h1>

        <div className="image-wrapper">
          <img
            src={pollutionImg}
            alt="Air Pollution"
            className="top-image"
          />
          <div className="image-overlay">
            <h2>Air Pollution Awareness</h2>
            <p>
              Protecting clean air is essential for
              human health, nature, and future generations.
            </p>
          </div>
        </div>

        <p className="intro-text">
          Air pollution occurs when harmful gases,
          smoke, dust, and toxic chemicals contaminate
          the atmosphere and negatively affect human
          health and the environment.
        </p>

        <div className="cause-box">
          <h2>Burning of Fossil Fuels</h2>
          <p>
            Burning fossil fuels such as coal, petrol,
            and diesel releases dangerous gases into
            the atmosphere. These pollutants increase
            global warming and reduce air quality.
          </p>
          <p>
            Power plants, factories, and vehicles heavily
            depend on fossil fuels, making them one of
            the largest contributors to air pollution.
          </p>

          <h2>Automobiles</h2>
          <p>
            Cars, buses, trucks, and motorcycles emit
            harmful smoke and greenhouse gases into
            the environment.
          </p>
          <p>
            Vehicle emissions release nitrogen oxides
            and carbon monoxide which can cause
            breathing problems and lung diseases.
          </p>

          <h2>Agricultural Activities</h2>
          <p>
            Fertilizers, pesticides, and insecticides
            release ammonia and toxic chemicals into
            the atmosphere.
          </p>
          <p>
            Burning crop waste also contributes
            significantly to air pollution.
          </p>

          <h2>Factories and Industries</h2>
          <p>
            Factories release smoke, hydrocarbons,
            and harmful chemicals into the air,
            reducing environmental quality.
          </p>
          <p>
            Industrial pollution affects nearby
            communities and contributes to climate change.
          </p>

          <h2>Mining Activities</h2>
          <p>
            Mining activities generate dust particles
            and harmful pollutants that contaminate
            nearby environments.
          </p>
          <p>
            Workers and nearby residents are exposed
            to dangerous airborne particles.
          </p>

          <h2>Domestic Sources</h2>
          <p>
            Household cleaning products, paints,
            and chemicals release toxic fumes
            into indoor air.
          </p>
          <p>
            Poor ventilation inside homes can
            increase indoor air pollution and
            create serious health problems.
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AirCauses;